import axios from 'axios';
import config from './environment';

// Log current environment for debugging
console.log('Current environment:', config.getEnvironmentInfo());

// Create axios instance with base URL from environment variable
const api = axios.create({
  baseURL: config.API_URL,
  timeout: 300000, // 5 minutes for large file uploads
  // Enable credentials for production if needed
  withCredentials: config.isProduction,
  // Add max content length for large files
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

// Request interceptor for adding auth tokens if needed
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Set Content-Type to application/json for regular requests
    // Let axios handle multipart/form-data for file uploads
    if (!config.data || !(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    // Log request details for debugging
    console.log('Making request to:', config.baseURL + config.url);
    console.log('Request headers:', config.headers);
    console.log('Request data type:', config.data instanceof FormData ? 'FormData' : typeof config.data);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Enhanced CORS/Network error handling
    if (error.code === 'ERR_NETWORK') {
      console.error('CORS/Network Error Details:', {
        message: error.message,
        config: error.config,
        request: error.request,
        environment: config.getEnvironmentInfo()
      });

      if (error.message.includes('Network Error')) {
        if (config.isProduction) {
          console.error('Production CORS Issue: The backend server (https://api.aarogai.com) needs to allow requests from:', window.location.origin);
          console.error('Backend CORS configuration should include:', window.location.origin);
        } else {
          console.error('Development CORS Issue: Check if proxy is working or backend server is running');
        }
      }
    }

    // Handle unauthorized access
    if (error.response?.status === 401) {
      console.error('Unauthorized access');
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }

    // Handle CORS preflight errors
    if (error.response?.status === 0) {
      console.error('CORS Preflight Error: The server is not responding to OPTIONS requests');
      console.error('Backend needs proper CORS configuration for:', window.location.origin);
    }

    return Promise.reject(error);
  }
);

export default api;
